var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows-up-down-left-right-solid 1",
    clipPath: "url(#clip0_351_66362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1393 0.293762C9.72445 -0.0968628 9.05078 -0.0968628 8.63596 0.293762L6.51206 2.29376C6.09724 2.68439 6.09724 3.31876 6.51206 3.70939C6.92689 4.10001 7.60056 4.10001 8.01538 3.70939L8.32733 3.41564V7.00001H4.52091L4.83286 6.70626C5.24768 6.31564 5.24768 5.68126 4.83286 5.29064C4.41804 4.90001 3.74437 4.90001 3.32954 5.29064L1.20565 7.29064C0.790826 7.68126 0.790826 8.31564 1.20565 8.70626L3.32954 10.7063C3.74437 11.0969 4.41804 11.0969 4.83286 10.7063C5.24768 10.3156 5.24768 9.68126 4.83286 9.29064L4.52091 8.99689H8.32733V12.5844L8.01538 12.2906C7.60056 11.9 6.92689 11.9 6.51206 12.2906C6.09724 12.6813 6.09724 13.3156 6.51206 13.7063L8.63596 15.7063C9.05078 16.0969 9.72445 16.0969 10.1393 15.7063L12.2632 13.7063C12.678 13.3156 12.678 12.6813 12.2632 12.2906C11.8483 11.9 11.1747 11.9 10.7599 12.2906L10.4479 12.5844V9.00001H14.2576L13.9457 9.29376C13.5309 9.68439 13.5309 10.3188 13.9457 10.7094C14.3605 11.1 15.0342 11.1 15.449 10.7094L17.5729 8.70939C17.9877 8.31876 17.9877 7.68439 17.5729 7.29376L15.449 5.29376C15.0342 4.90314 14.3605 4.90314 13.9457 5.29376C13.5309 5.68439 13.5309 6.31876 13.9457 6.70939L14.2576 7.00314H10.4512V3.41564L10.7632 3.70939C11.178 4.10001 11.8517 4.10001 12.2665 3.70939C12.6813 3.31876 12.6813 2.68439 12.2665 2.29376L10.1426 0.293762H10.1393Z",
    fill: "#BBC2C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_66362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9911,
    height: 16,
    fill: "white",
    transform: "translate(0.893555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsImage);
export default __webpack_public_path__ + "static/media/arrows_image.f98f49b8faee40ea61123c53cff675e1.svg";
export { ForwardRef as ReactComponent };